<section *ngIf="!maintenanceMode" #scroll>
  <app-tenant-configuration
    *ngIf="
    showTenantSelection.includes(title) &&
      (tenantId === null || tenantId === '');
    else showLandingPage
  "
  ></app-tenant-configuration>

  <ng-template #showLandingPage>
    <section #scroll class="container mw-100 px-0" *ngIf="initializeApp">
      <app-header *ngIf="showHeader"></app-header>
      <div class="page">
        <p-toast position="top-right"></p-toast>
        <router-outlet></router-outlet>
        <app-footer (scrollToTop)="scrollToTop()"></app-footer>
      </div>
    </section>
  </ng-template>
</section>

<app-maintenance *ngIf="maintenanceMode"></app-maintenance>
